import { get, head, split } from "lodash";
import { lighten } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";

const CLASSIFICATIONS = [
  "adult",
  "arts_and_entertainment",
  "arts_and_entertainment/celebrities_and_entertainment_news",
  "arts_and_entertainment/comics_and_animation",
  "arts_and_entertainment/comics_and_animation/anime_and_manga",
  "arts_and_entertainment/comics_and_animation/cartoons",
  "arts_and_entertainment/comics_and_animation/comics",
  "arts_and_entertainment/entertainment_industry",
  "arts_and_entertainment/entertainment_industry/film_and_tv_industry",
  "arts_and_entertainment/entertainment_industry/recording_industry",
  "arts_and_entertainment/events_and_listings",
  "arts_and_entertainment/events_and_listings/bars_clubs_and_nightlife",
  "arts_and_entertainment/events_and_listings/concerts_and_music_festivals",
  "arts_and_entertainment/events_and_listings/event_ticket_sales",
  "arts_and_entertainment/events_and_listings/expos_and_conventions",
  "arts_and_entertainment/events_and_listings/film_festivals",
  "arts_and_entertainment/events_and_listings/food_and_beverage_events",
  "arts_and_entertainment/events_and_listings/live_sporting_events",
  "arts_and_entertainment/events_and_listings/movie_listings_and_theater_showtimes",
  "arts_and_entertainment/fun_and_trivia",
  "arts_and_entertainment/fun_and_trivia/flash_based_entertainment",
  "arts_and_entertainment/fun_and_trivia/fun_tests_and_silly_surveys",
  "arts_and_entertainment/humor",
  "arts_and_entertainment/humor/funny_pictures_and_videos",
  "arts_and_entertainment/humor/live_comedy",
  "arts_and_entertainment/humor/political_humor",
  "arts_and_entertainment/humor/spoofs_and_satire",
  "arts_and_entertainment/movies",
  "arts_and_entertainment/movies/action_and_adventure_films",
  "arts_and_entertainment/movies/animated_films",
  "arts_and_entertainment/movies/bollywood_and_south_asian_film",
  "arts_and_entertainment/movies/classic_films",
  "arts_and_entertainment/movies/comedy_films",
  "arts_and_entertainment/movies/cult_and_indie_films",
  "arts_and_entertainment/movies/dvd_and_video_shopping",
  "arts_and_entertainment/movies/documentary_films",
  "arts_and_entertainment/movies/drama_films",
  "arts_and_entertainment/movies/family_films",
  "arts_and_entertainment/movies/horror_films",
  "arts_and_entertainment/movies/movie_memorabilia",
  "arts_and_entertainment/movies/movie_reference",
  "arts_and_entertainment/movies/musical_films",
  "arts_and_entertainment/movies/romance_films",
  "arts_and_entertainment/movies/science_fiction_and_fantasy_films",
  "arts_and_entertainment/movies/thriller_crime_and_mystery_films",
  "arts_and_entertainment/music_and_audio",
  "arts_and_entertainment/music_and_audio/cd_and_audio_shopping",
  "arts_and_entertainment/music_and_audio/classical_music",
  "arts_and_entertainment/music_and_audio/country_music",
  "arts_and_entertainment/music_and_audio/dance_and_electronic_music",
  "arts_and_entertainment/music_and_audio/experimental_and_industrial_music",
  "arts_and_entertainment/music_and_audio/folk_and_traditional_music",
  "arts_and_entertainment/music_and_audio/jazz_and_blues",
  "arts_and_entertainment/music_and_audio/music_art_and_memorabilia",
  "arts_and_entertainment/music_and_audio/music_education_and_instruction",
  "arts_and_entertainment/music_and_audio/music_equipment_and_technology",
  "arts_and_entertainment/music_and_audio/music_reference",
  "arts_and_entertainment/music_and_audio/music_streams_and_downloads",
  "arts_and_entertainment/music_and_audio/music_videos",
  "arts_and_entertainment/music_and_audio/podcasts",
  "arts_and_entertainment/music_and_audio/pop_music",
  "arts_and_entertainment/music_and_audio/radio",
  "arts_and_entertainment/music_and_audio/religious_music",
  "arts_and_entertainment/music_and_audio/rock_music",
  "arts_and_entertainment/music_and_audio/soundtracks",
  "arts_and_entertainment/music_and_audio/urban_and_hiphop",
  "arts_and_entertainment/music_and_audio/vocals_and_show_tunes",
  "arts_and_entertainment/music_and_audio/world_music",
  "arts_and_entertainment/offbeat",
  "arts_and_entertainment/offbeat/occult_and_paranormal",
  "arts_and_entertainment/online_media",
  "arts_and_entertainment/online_media/online_image_galleries",
  "arts_and_entertainment/online_media/virtual_tours",
  "arts_and_entertainment/performing_arts",
  "arts_and_entertainment/performing_arts/acting_and_theater",
  "arts_and_entertainment/performing_arts/broadway_and_musical_theater",
  "arts_and_entertainment/performing_arts/circus",
  "arts_and_entertainment/performing_arts/dance",
  "arts_and_entertainment/performing_arts/magic",
  "arts_and_entertainment/performing_arts/opera",
  "arts_and_entertainment/tv_and_video",
  "arts_and_entertainment/tv_and_video/online_video",
  "arts_and_entertainment/tv_and_video/tv_commercials",
  "arts_and_entertainment/tv_and_video/tv_guides_and_reference",
  "arts_and_entertainment/tv_and_video/tv_networks_and_stations",
  "arts_and_entertainment/tv_and_video/tv_shows_and_programs",
  "arts_and_entertainment/visual_art_and_design",
  "arts_and_entertainment/visual_art_and_design/architecture",
  "arts_and_entertainment/visual_art_and_design/art_museums_and_galleries",
  "arts_and_entertainment/visual_art_and_design/design",
  "arts_and_entertainment/visual_art_and_design/painting",
  "arts_and_entertainment/visual_art_and_design/photographic_and_digital_arts",
  "arts_and_entertainment/visual_art_and_design/sculpture",
  "arts_and_entertainment/visual_art_and_design/visual_arts_and_design_education",
  "autos_and_vehicles",
  "autos_and_vehicles/bicycles_and_accessories",
  "autos_and_vehicles/bicycles_and_accessories/bmx_bikes",
  "autos_and_vehicles/bicycles_and_accessories/bike_accessories",
  "autos_and_vehicles/bicycles_and_accessories/bike_frames",
  "autos_and_vehicles/bicycles_and_accessories/bike_helmets_and_protective_gear",
  "autos_and_vehicles/bicycles_and_accessories/bike_parts_and_repair",
  "autos_and_vehicles/bicycles_and_accessories/electric_bicycles",
  "autos_and_vehicles/bicycles_and_accessories/kids_bikes",
  "autos_and_vehicles/bicycles_and_accessories/mountain_bikes",
  "autos_and_vehicles/bicycles_and_accessories/road_bikes",
  "autos_and_vehicles/boats_and_watercraft",
  "autos_and_vehicles/campers_and_rvs",
  "autos_and_vehicles/classic_vehicles",
  "autos_and_vehicles/commercial_vehicles",
  "autos_and_vehicles/commercial_vehicles/cargo_trucks_and_trailers",
  "autos_and_vehicles/custom_and_performance_vehicles",
  "autos_and_vehicles/motor_vehicles_brand",
  "autos_and_vehicles/motor_vehicles_brand/audi",
  "autos_and_vehicles/motor_vehicles_brand/bmw",
  "autos_and_vehicles/motor_vehicles_brand/bentley",
  "autos_and_vehicles/motor_vehicles_brand/buick",
  "autos_and_vehicles/motor_vehicles_brand/cadillac",
  "autos_and_vehicles/motor_vehicles_brand/chevrolet",
  "autos_and_vehicles/motor_vehicles_brand/chrysler",
  "autos_and_vehicles/motor_vehicles_brand/citroën",
  "autos_and_vehicles/motor_vehicles_brand/dodge",
  "autos_and_vehicles/motor_vehicles_brand/ferrari",
  "autos_and_vehicles/motor_vehicles_brand/fiat",
  "autos_and_vehicles/motor_vehicles_brand/ford",
  "autos_and_vehicles/motor_vehicles_brand/gmc",
  "autos_and_vehicles/motor_vehicles_brand/honda",
  "autos_and_vehicles/motor_vehicles_brand/hyundai",
  "autos_and_vehicles/motor_vehicles_brand/jaguar",
  "autos_and_vehicles/motor_vehicles_brand/jeep",
  "autos_and_vehicles/motor_vehicles_brand/kia",
  "autos_and_vehicles/motor_vehicles_brand/lamborghini",
  "autos_and_vehicles/motor_vehicles_brand/land_rover",
  "autos_and_vehicles/motor_vehicles_brand/lincoln",
  "autos_and_vehicles/motor_vehicles_brand/mazda",
  "autos_and_vehicles/motor_vehicles_brand/mercedes_benz",
  "autos_and_vehicles/motor_vehicles_brand/mercury",
  "autos_and_vehicles/motor_vehicles_brand/mini",
  "autos_and_vehicles/motor_vehicles_brand/mitsubishi",
  "autos_and_vehicles/motor_vehicles_brand/nissan",
  "autos_and_vehicles/motor_vehicles_brand/pontiac",
  "autos_and_vehicles/motor_vehicles_brand/porsche",
  "autos_and_vehicles/motor_vehicles_brand/ram_trucks",
  "autos_and_vehicles/motor_vehicles_brand/renault",
  "autos_and_vehicles/motor_vehicles_brand/rolls_royce",
  "autos_and_vehicles/motor_vehicles_brand/skoda",
  "autos_and_vehicles/motor_vehicles_brand/subaru",
  "autos_and_vehicles/motor_vehicles_brand/suzuki",
  "autos_and_vehicles/motor_vehicles_brand/tesla_motors",
  "autos_and_vehicles/motor_vehicles_brand/toyota",
  "autos_and_vehicles/motor_vehicles_brand/vauxhall_opel",
  "autos_and_vehicles/motor_vehicles_brand/volkswagen",
  "autos_and_vehicles/motor_vehicles_brand/volvo",
  "autos_and_vehicles/motor_vehicles_type",
  "autos_and_vehicles/motor_vehicles_type/autonomous_vehicles",
  "autos_and_vehicles/motor_vehicles_type/compact_cars",
  "autos_and_vehicles/motor_vehicles_type/convertibles",
  "autos_and_vehicles/motor_vehicles_type/coupes",
  "autos_and_vehicles/motor_vehicles_type/diesel_vehicles",
  "autos_and_vehicles/motor_vehicles_type/hatchbacks",
  "autos_and_vehicles/motor_vehicles_type/hybrid_and_alternative_vehicles",
  "autos_and_vehicles/motor_vehicles_type/luxury_vehicles",
  "autos_and_vehicles/motor_vehicles_type/microcars_and_subcompacts",
  "autos_and_vehicles/motor_vehicles_type/motorcycles",
  "autos_and_vehicles/motor_vehicles_type/off_road_vehicles",
  "autos_and_vehicles/motor_vehicles_type/scooters_and_mopeds",
  "autos_and_vehicles/motor_vehicles_type/sedans",
  "autos_and_vehicles/motor_vehicles_type/sports_cars",
  "autos_and_vehicles/motor_vehicles_type/trucks_and_suvs",
  "autos_and_vehicles/personal_aircraft",
  "autos_and_vehicles/vehicle_codes_and_driving_laws",
  "autos_and_vehicles/vehicle_codes_and_driving_laws/drunk_driving_law",
  "autos_and_vehicles/vehicle_codes_and_driving_laws/vehicle_licensing_and_registration",
  "autos_and_vehicles/vehicle_parts_and_services",
  "autos_and_vehicles/vehicle_parts_and_services/gas_prices_and_vehicle_fueling",
  "autos_and_vehicles/vehicle_parts_and_services/towing_and_roadside_assistance",
  "autos_and_vehicles/vehicle_parts_and_services/vehicle_modification_and_tuning",
  "autos_and_vehicles/vehicle_parts_and_services/vehicle_parts_and_accessories",
  "autos_and_vehicles/vehicle_parts_and_services/vehicle_repair_and_maintenance",
  "autos_and_vehicles/vehicle_shopping",
  "autos_and_vehicles/vehicle_shopping/used_vehicles",
  "autos_and_vehicles/vehicle_shopping/vehicle_dealers_and_retailers",
  "autos_and_vehicles/vehicle_shopping/vehicle_specs_reviews_and_comparisons",
  "autos_and_vehicles/vehicle_shows",
  "beauty_and_fitness",
  "beauty_and_fitness/beauty_pageants",
  "beauty_and_fitness/cosmetic_procedures",
  "beauty_and_fitness/cosmetic_procedures/cosmetic_surgery",
  "beauty_and_fitness/spas_and_beauty_services",
  "beauty_and_fitness/spas_and_beauty_services/manicures_and_pedicures",
  "beauty_and_fitness/spas_and_beauty_services/massage_therapy",
  "beauty_and_fitness/body_art",
  "beauty_and_fitness/cosmetology_and_beauty_professionals",
  "beauty_and_fitness/face_and_body_care",
  "beauty_and_fitness/face_and_body_care/clean_beauty",
  "beauty_and_fitness/face_and_body_care/hygiene_and_toiletries",
  "beauty_and_fitness/face_and_body_care/makeup_and_cosmetics",
  "beauty_and_fitness/face_and_body_care/perfumes_and_fragrances",
  "beauty_and_fitness/face_and_body_care/skin_and_nail_care",
  "beauty_and_fitness/face_and_body_care/sun_care_and_tanning_products",
  "beauty_and_fitness/face_and_body_care/unwanted_body_and_facial_hair_removal",
  "beauty_and_fitness/fashion_and_style",
  "beauty_and_fitness/fashion_and_style/fashion_designers_and_collections",
  "beauty_and_fitness/fitness",
  "beauty_and_fitness/fitness/bodybuilding",
  "beauty_and_fitness/fitness/fitness_equipment_and_accessories",
  "beauty_and_fitness/fitness/fitness_instruction_and_personal_training",
  "beauty_and_fitness/fitness/gyms_and_health_clubs",
  "beauty_and_fitness/fitness/high_intensity_interval_training",
  "beauty_and_fitness/fitness/yoga_and_pilates",
  "beauty_and_fitness/hair_care",
  "beauty_and_fitness/hair_care/hair_loss",
  "beauty_and_fitness/hair_care/shampoos_and_conditioners",
  "beauty_and_fitness/weight_loss",
  "books_and_literature",
  "books_and_literature/audiobooks",
  "books_and_literature/book_retailers",
  "books_and_literature/children_literature",
  "books_and_literature/e_books",
  "books_and_literature/fan_fiction",
  "books_and_literature/literary_classics",
  "books_and_literature/poetry",
  "books_and_literature/writers_resources",
  "business_and_industrial",
  "business_and_industrial/advertising_and_marketing",
  "business_and_industrial/advertising_and_marketing/brand_management",
  "business_and_industrial/advertising_and_marketing/marketing",
  "business_and_industrial/advertising_and_marketing/public_relations",
  "business_and_industrial/advertising_and_marketing/sales",
  "business_and_industrial/advertising_and_marketing/telemarketing",
  "business_and_industrial/aerospace_and_defense",
  "business_and_industrial/aerospace_and_defense/aviation_industry",
  "business_and_industrial/aerospace_and_defense/space_technology",
  "business_and_industrial/agriculture_and_forestry",
  "business_and_industrial/agriculture_and_forestry/agricultural_equipment",
  "business_and_industrial/agriculture_and_forestry/aquaculture",
  "business_and_industrial/agriculture_and_forestry/crops_and_seed",
  "business_and_industrial/agriculture_and_forestry/farms_and_ranches",
  "business_and_industrial/agriculture_and_forestry/forestry",
  "business_and_industrial/agriculture_and_forestry/livestock",
  "business_and_industrial/automotive_industry",
  "business_and_industrial/business_education",
  "business_and_industrial/business_finance",
  "business_and_industrial/business_finance/commercial_lending",
  "business_and_industrial/business_finance/investment_banking",
  "business_and_industrial/business_finance/risk_management",
  "business_and_industrial/business_finance/venture_capital",
  "business_and_industrial/business_operations",
  "business_and_industrial/business_operations/business_plans_and_presentations",
  "business_and_industrial/business_operations/flexible_work_arrangements",
  "business_and_industrial/business_operations/human_resources",
  "business_and_industrial/business_operations/management",
  "business_and_industrial/business_services",
  "business_and_industrial/business_services/commercial_distribution",
  "business_and_industrial/business_services/consulting",
  "business_and_industrial/business_services/corporate_events",
  "business_and_industrial/business_services/e_commerce_services",
  "business_and_industrial/business_services/fire_and_security_services",
  "business_and_industrial/business_services/knowledge_management",
  "business_and_industrial/business_services/office_services",
  "business_and_industrial/business_services/office_supplies",
  "business_and_industrial/business_services/outsourcing",
  "business_and_industrial/business_services/physical_asset_management",
  "business_and_industrial/business_services/quality_control_and_tracking",
  "business_and_industrial/business_services/shared_workspaces",
  "business_and_industrial/business_services/signage",
  "business_and_industrial/business_services/warehousing",
  "business_and_industrial/business_services/writing_and_editing_services",
  "business_and_industrial/chemicals_industry",
  "business_and_industrial/chemicals_industry/agrochemicals",
  "business_and_industrial/chemicals_industry/cleaning_agents",
  "business_and_industrial/chemicals_industry/coatings_and_adhesives",
  "business_and_industrial/chemicals_industry/dyes_and_pigments",
  "business_and_industrial/chemicals_industry/plastics_and_polymers",
  "business_and_industrial/construction_and_maintenance",
  "business_and_industrial/construction_and_maintenance/building_materials_and_supplies",
  "business_and_industrial/construction_and_maintenance/civil_engineering",
  "business_and_industrial/energy_and_utilities",
  "business_and_industrial/energy_and_utilities/electricity",
  "business_and_industrial/energy_and_utilities/nuclear_energy",
  "business_and_industrial/energy_and_utilities/oil_and_gas",
  "business_and_industrial/energy_and_utilities/renewable_and_alternative_energy",
  "business_and_industrial/energy_and_utilities/waste_management",
  "business_and_industrial/hospitality_industry",
  "business_and_industrial/hospitality_industry/event_planning",
  "business_and_industrial/hospitality_industry/event_venue_rentals",
  "business_and_industrial/hospitality_industry/food_service",
  "business_and_industrial/industrial_materials_and_equipment",
  "business_and_industrial/industrial_materials_and_equipment/fluid_handling",
  "business_and_industrial/industrial_materials_and_equipment/generators",
  "business_and_industrial/industrial_materials_and_equipment/heavy_machinery",
  "business_and_industrial/industrial_materials_and_equipment/industrial_handling_and_processing_equipment",
  "business_and_industrial/manufacturing",
  "business_and_industrial/manufacturing/factory_automation",
  "business_and_industrial/metals_and_mining",
  "business_and_industrial/metals_and_mining/precious_metals",
  "business_and_industrial/pharmaceuticals_and_biotech",
  "business_and_industrial/printing_and_publishing",
  "business_and_industrial/printing_and_publishing/document_and_printing_services",
  "business_and_industrial/retail_trade",
  "business_and_industrial/retail_trade/retail_equipment_and_technology",
  "business_and_industrial/transportation_and_logistics",
  "business_and_industrial/transportation_and_logistics/import_and_export",
  "business_and_industrial/transportation_and_logistics/mail_and_package_delivery",
  "business_and_industrial/transportation_and_logistics/maritime_freight_transport",
  "business_and_industrial/transportation_and_logistics/moving_and_relocation",
  "business_and_industrial/transportation_and_logistics/other_freight_transport",
  "business_and_industrial/transportation_and_logistics/packaging",
  "business_and_industrial/transportation_and_logistics/rail_transport",
  "business_and_industrial/transportation_and_logistics/self_storage",
  "business_and_industrial/small_business",
  "business_and_industrial/small_business/business_formation",
  "business_and_industrial/small_business/home_office",
  "business_and_industrial/small_business/mlm_and_business_opportunities",
  "business_and_industrial/textiles_and_nonwovens",
  "computers_and_electronics",
  "computers_and_electronics/cad_and_cam",
  "computers_and_electronics/computer_hardware",
  "computers_and_electronics/computer_hardware/computer_components",
  "computers_and_electronics/computer_hardware/computer_drives_and_storage",
  "computers_and_electronics/computer_hardware/computer_peripherals",
  "computers_and_electronics/computer_hardware/computer_servers",
  "computers_and_electronics/computer_hardware/desktop_computers",
  "computers_and_electronics/computer_hardware/hardware_modding_and_tuning",
  "computers_and_electronics/computer_hardware/laptops_and_notebooks",
  "computers_and_electronics/computer_security",
  "computers_and_electronics/computer_security/antivirus_and_malware",
  "computers_and_electronics/computer_security/hacking_and_cracking",
  "computers_and_electronics/computer_security/network_security",
  "computers_and_electronics/consumer_electronics",
  "computers_and_electronics/consumer_electronics/audio_equipment",
  "computers_and_electronics/consumer_electronics/camera_and_photo_equipment",
  "computers_and_electronics/consumer_electronics/car_electronics",
  "computers_and_electronics/consumer_electronics/drones_and_rc_aircraft",
  "computers_and_electronics/consumer_electronics/electronic_accessories",
  "computers_and_electronics/consumer_electronics/gps_and_navigation",
  "computers_and_electronics/consumer_electronics/gadgets_and_portable_electronics",
  "computers_and_electronics/consumer_electronics/game_systems_and_consoles",
  "computers_and_electronics/consumer_electronics/home_automation",
  "computers_and_electronics/consumer_electronics/media_streaming_devices",
  "computers_and_electronics/consumer_electronics/tv_and_video_equipment",
  "computers_and_electronics/consumer_electronics/virtual_reality_devices",
  "computers_and_electronics/electronics_and_electrical",
  "computers_and_electronics/electronics_and_electrical/data_sheets_and_electronics_reference",
  "computers_and_electronics/electronics_and_electrical/electrical_test_and_measurement",
  "computers_and_electronics/electronics_and_electrical/electromechanical_devices",
  "computers_and_electronics/electronics_and_electrical/electronic_components",
  "computers_and_electronics/electronics_and_electrical/optoelectronics_and_fiber",
  "computers_and_electronics/electronics_and_electrical/power_supplies",
  "computers_and_electronics/enterprise_technology",
  "computers_and_electronics/enterprise_technology/customer_relationship_management_crm",
  "computers_and_electronics/enterprise_technology/data_management",
  "computers_and_electronics/enterprise_technology/enterprise_resource_planning_erp",
  "computers_and_electronics/enterprise_technology/helpdesk_and_customer_support_systems",
  "computers_and_electronics/networking",
  "computers_and_electronics/networking/data_formats_and_protocols",
  "computers_and_electronics/networking/distributed_and_cloud_computing",
  "computers_and_electronics/networking/network_monitoring_and_management",
  "computers_and_electronics/networking/networking_equipment",
  "computers_and_electronics/networking/vpn_and_remote_access",
  "computers_and_electronics/programming",
  "computers_and_electronics/programming/c_and_c_plus_plus",
  "computers_and_electronics/programming/development_tools",
  "computers_and_electronics/programming/java_programming_language",
  "computers_and_electronics/programming/scripting_languages",
  "computers_and_electronics/programming/windows_and_.net",
  "computers_and_electronics/software",
  "computers_and_electronics/software/business_and_productivity_software",
  "computers_and_electronics/software/device_drivers",
  "computers_and_electronics/software/educational_software",
  "computers_and_electronics/software/freeware_and_shareware",
  "computers_and_electronics/software/intelligent_personal_assistants",
  "computers_and_electronics/software/internet_software",
  "computers_and_electronics/software/monitoring_software",
  "computers_and_electronics/software/multimedia_software",
  "computers_and_electronics/software/open_source",
  "computers_and_electronics/software/operating_systems",
  "computers_and_electronics/software/software_utilities",
  "finance",
  "finance/accounting_and_auditing",
  "finance/accounting_and_auditing/billing_and_invoicing",
  "finance/accounting_and_auditing/bookkeeping",
  "finance/accounting_and_auditing/tax_preparation_and_planning",
  "finance/banking",
  "finance/banking/atms_and_branch_locations",
  "finance/banking/debit_and_checking_services",
  "finance/banking/mobile_payments_and_digital_wallets",
  "finance/banking/money_transfer_and_wire_services",
  "finance/banking/savings_accounts",
  "finance/credit_and_lending",
  "finance/credit_and_lending/credit_cards",
  "finance/credit_and_lending/credit_reporting_and_monitoring",
  "finance/credit_and_lending/debt_collection_and_repossession",
  "finance/credit_and_lending/debt_management",
  "finance/credit_and_lending/loans",
  "finance/crowdfunding",
  "finance/financial_planning_and_management",
  "finance/financial_planning_and_management/asset_and_portfolio_management",
  "finance/financial_planning_and_management/inheritance_and_estate_planning",
  "finance/financial_planning_and_management/retirement_and_pension",
  "finance/grants_scholarships_and_financial_aid",
  "finance/grants_scholarships_and_financial_aid/government_grants",
  "finance/grants_scholarships_and_financial_aid/study_grants_and_scholarships",
  "finance/insurance",
  "finance/insurance/health_insurance",
  "finance/insurance/home_insurance",
  "finance/insurance/life_insurance",
  "finance/insurance/travel_insurance",
  "finance/insurance/vehicle_insurance",
  "finance/investing",
  "finance/investing/brokerages_and_day_trading",
  "finance/investing/commodities_and_futures_trading",
  "finance/investing/currencies_and_foreign_exchange",
  "finance/investing/derivatives",
  "finance/investing/funds",
  "finance/investing/real_estate_investment_trusts",
  "finance/investing/socially_responsible_investing",
  "finance/investing/stocks_and_bonds",
  "food_and_drink",
  "food_and_drink/beverages",
  "food_and_drink/beverages/alcohol_free_beverages",
  "food_and_drink/beverages/alcoholic_beverages",
  "food_and_drink/beverages/bottled_water",
  "food_and_drink/beverages/coffee_and_tea",
  "food_and_drink/beverages/energy_drinks",
  "food_and_drink/beverages/juice",
  "food_and_drink/beverages/nutrition_drinks_and_shakes",
  "food_and_drink/beverages/soft_drinks",
  "food_and_drink/cooking_and_recipes",
  "food_and_drink/cooking_and_recipes/bbq_and_grilling",
  "food_and_drink/cooking_and_recipes/cuisines",
  "food_and_drink/cooking_and_recipes/culinary_training",
  "food_and_drink/cooking_and_recipes/desserts",
  "food_and_drink/cooking_and_recipes/healthy_eating",
  "food_and_drink/cooking_and_recipes/salads",
  "food_and_drink/cooking_and_recipes/soups_and_stews",
  "food_and_drink/food",
  "food_and_drink/food_and_grocery_delivery",
  "food_and_drink/food_and_grocery_delivery/grocery_delivery_services",
  "food_and_drink/food_and_grocery_delivery/meal_kits",
  "food_and_drink/food_and_grocery_delivery/restaurant_delivery_services",
  "food_and_drink/food_and_grocery_retailers",
  "food_and_drink/food_and_grocery_retailers/bakeries",
  "food_and_drink/food_and_grocery_retailers/butchers",
  "food_and_drink/food_and_grocery_retailers/convenience_stores",
  "food_and_drink/food_and_grocery_retailers/delicatessens",
  "food_and_drink/food_and_grocery_retailers/farmers_markets",
  "food_and_drink/food/baked_goods",
  "food_and_drink/food/breakfast_foods",
  "food_and_drink/food/candy_and_sweets",
  "food_and_drink/food/condiments_and_dressings",
  "food_and_drink/food/cooking_fats_and_oils",
  "food_and_drink/food/dairy_and_egg_substitutes",
  "food_and_drink/food/dairy_and_eggs",
  "food_and_drink/food/fruits_and_vegetables",
  "food_and_drink/food/gourmet_and_specialty_foods",
  "food_and_drink/food/grains_and_pasta",
  "food_and_drink/food/herbs_and_spices",
  "food_and_drink/food/jams_jellies_and_preserves",
  "food_and_drink/food/meat_and_seafood",
  "food_and_drink/food/meat_and_seafood_substitutes",
  "food_and_drink/food/organic_and_natural_foods",
  "food_and_drink/food/snack_foods",
  "food_and_drink/restaurants",
  "food_and_drink/restaurants/catering",
  "food_and_drink/restaurants/fast_food",
  "food_and_drink/restaurants/fine_dining",
  "food_and_drink/restaurants/pizzerias",
  "food_and_drink/restaurants/restaurant_reviews_and_reservations",
  "games",
  "games/arcade_and_coin_op_games",
  "games/board_games",
  "games/board_games/chess_and_abstract_strategy_games",
  "games/board_games/miniatures_and_wargaming",
  "games/card_games",
  "games/card_games/collectible_card_games",
  "games/card_games/poker_and_casino_games",
  "games/computer_and_video_games",
  "games/computer_and_video_games/action_and_platform_games",
  "games/computer_and_video_games/adventure_games",
  "games/computer_and_video_games/browser_games",
  "games/computer_and_video_games/casual_games",
  "games/computer_and_video_games/competitive_video_gaming",
  "games/computer_and_video_games/driving_and_racing_games",
  "games/computer_and_video_games/fighting_games",
  "games/computer_and_video_games/gaming_reference_and_reviews",
  "games/computer_and_video_games/music_and_dance_games",
  "games/computer_and_video_games/sandbox_games",
  "games/computer_and_video_games/shooter_games",
  "games/computer_and_video_games/simulation_games",
  "games/computer_and_video_games/sports_games",
  "games/computer_and_video_games/strategy_games",
  "games/computer_and_video_games/video_game_development",
  "games/computer_and_video_games/video_game_emulation",
  "games/computer_and_video_games/video_game_mods_and_add_ons",
  "games/computer_and_video_games/video_game_retailers",
  "games/dice_games",
  "games/educational_games",
  "games/family_oriented_games_and_activities",
  "games/family_oriented_games_and_activities/drawing_and_coloring",
  "games/family_oriented_games_and_activities/dress_up_and_fashion_games",
  "games/gambling",
  "games/gambling/lottery",
  "games/gambling/sports_betting",
  "games/online_games",
  "games/online_games/massively_multiplayer_games",
  "games/party_games",
  "games/puzzles_and_brainteasers",
  "games/roleplaying_games",
  "games/table_games",
  "games/table_games/billiards",
  "games/table_games/table_tennis",
  "games/tile_games",
  "games/word_games",
  "health",
  "health/aging_and_geriatrics",
  "health/aging_and_geriatrics/alzheimer_disease",
  "health/alternative_and_natural_medicine",
  "health/alternative_and_natural_medicine/acupuncture_and_chinese_medicine",
  "health/alternative_and_natural_medicine/cleansing_and_detoxification",
  "health/health_conditions",
  "health/health_conditions/aids_and_hiv",
  "health/health_conditions/arthritis",
  "health/health_conditions/cancer",
  "health/health_conditions/covid_19",
  "health/health_conditions/diabetes",
  "health/health_conditions/ear_nose_and_throat",
  "health/health_conditions/eating_disorders",
  "health/health_conditions/endocrine_conditions",
  "health/health_conditions/environmental_allergies",
  "health/health_conditions/food_allergies",
  "health/health_conditions/gerd_and_digestive_disorders",
  "health/health_conditions/genetic_disorders",
  "health/health_conditions/heart_and_hypertension",
  "health/health_conditions/injury",
  "health/health_conditions/neurological_conditions",
  "health/health_conditions/obesity",
  "health/health_conditions/other_allergies",
  "health/health_conditions/infectious_diseases",
  "health/health_conditions/pain_management",
  "health/health_conditions/respiratory_conditions",
  "health/health_conditions/skin_conditions",
  "health/health_conditions/sleep_disorders",
  "health/health_conditions/vaccines_and_immunizations",
  "health/health_education_and_medical_training",
  "health/health_foundations_and_medical_research",
  "health/medical_devices_and_equipment",
  "health/medical_devices_and_equipment/assistive_technology",
  "health/medical_facilities_and_services",
  "health/medical_facilities_and_services/doctors_offices",
  "health/medical_facilities_and_services/hospitals_and_treatment_centers",
  "health/medical_facilities_and_services/medical_procedures",
  "health/medical_facilities_and_services/physical_therapy",
  "health/medical_literature_and_resources",
  "health/medical_literature_and_resources/medical_photos_and_illustration",
  "health/men_health",
  "health/mental_health",
  "health/mental_health/anxiety_and_stress",
  "health/mental_health/compulsive_gambling",
  "health/mental_health/counseling_services",
  "health/mental_health/depression",
  "health/nursing",
  "health/nursing/assisted_living_and_long_term_care",
  "health/nutrition",
  "health/nutrition/special_and_restricted_diets",
  "health/nutrition/vitamins_and_supplements",
  "health/oral_and_dental_care",
  "health/pediatrics",
  "health/pharmacy",
  "health/pharmacy/drugs_and_medications",
  "health/public_health",
  "health/public_health/health_policy",
  "health/public_health/occupational_health_and_safety",
  "health/public_health/toxic_substances_and_poisoning",
  "health/reproductive_health",
  "health/reproductive_health/birth_control",
  "health/reproductive_health/infertility",
  "health/reproductive_health/male_impotence",
  "health/reproductive_health/obgyn",
  "health/reproductive_health/sex_education_and_counseling",
  "health/substance_abuse",
  "health/substance_abuse/drug_and_alcohol_testing",
  "health/substance_abuse/drug_and_alcohol_treatment",
  "health/substance_abuse/smoking_and_smoking_cessation",
  "health/substance_abuse/steroids_and_performance_enhancing_drugs",
  "health/vision_care",
  "health/vision_care/eye_exams_and_optometry",
  "health/vision_care/eyeglasses_and_contacts",
  "health/vision_care/laser_vision_correction",
  "health/women_health",
  "hobbies_and_leisure",
  "hobbies_and_leisure/clubs_and_organizations",
  "hobbies_and_leisure/clubs_and_organizations/youth_organizations_and_resources",
  "hobbies_and_leisure/crafts",
  "hobbies_and_leisure/crafts/art_and_craft_supplies",
  "hobbies_and_leisure/crafts/ceramics_and_pottery",
  "hobbies_and_leisure/crafts/fiber_and_textile_arts",
  "hobbies_and_leisure/merit_prizes_and_contests",
  "hobbies_and_leisure/outdoors",
  "hobbies_and_leisure/outdoors/fishing",
  "hobbies_and_leisure/outdoors/hiking_and_camping",
  "hobbies_and_leisure/outdoors/hunting_and_shooting",
  "hobbies_and_leisure/paintball",
  "hobbies_and_leisure/radio_control_and_modeling",
  "hobbies_and_leisure/radio_control_and_modeling/model_trains_and_railroads",
  "hobbies_and_leisure/recreational_aviation",
  "hobbies_and_leisure/special_occasions",
  "hobbies_and_leisure/special_occasions/anniversaries",
  "hobbies_and_leisure/special_occasions/holidays_and_seasonal_events",
  "hobbies_and_leisure/special_occasions/weddings",
  "hobbies_and_leisure/sweepstakes_and_promotional_giveaways",
  "hobbies_and_leisure/water_activities",
  "hobbies_and_leisure/water_activities/boating",
  "hobbies_and_leisure/water_activities/diving_and_underwater_activities",
  "hobbies_and_leisure/water_activities/surf_and_swim",
  "home_and_garden",
  "home_and_garden/bed_and_bath",
  "home_and_garden/bed_and_bath/bathroom",
  "home_and_garden/bed_and_bath/bedroom",
  "home_and_garden/domestic_services",
  "home_and_garden/domestic_services/cleaning_services",
  "home_and_garden/hvac_and_climate_control",
  "home_and_garden/hvac_and_climate_control/air_conditioners",
  "home_and_garden/hvac_and_climate_control/air_filters_and_purifiers",
  "home_and_garden/hvac_and_climate_control/fireplaces_and_stoves",
  "home_and_garden/hvac_and_climate_control/heaters",
  "home_and_garden/hvac_and_climate_control/household_fans",
  "home_and_garden/home_and_interior_decor",
  "home_and_garden/home_appliances",
  "home_and_garden/home_appliances/vacuums_and_floor_care",
  "home_and_garden/home_appliances/water_filters_and_purifiers",
  "home_and_garden/home_furnishings",
  "home_and_garden/home_furnishings/clocks",
  "home_and_garden/home_furnishings/countertops",
  "home_and_garden/home_furnishings/curtains_and_window_treatments",
  "home_and_garden/home_furnishings/kitchen_and_dining_furniture",
  "home_and_garden/home_furnishings/lamps_and_lighting",
  "home_and_garden/home_furnishings/living_room_furniture",
  "home_and_garden/home_furnishings/outdoor_furniture",
  "home_and_garden/home_furnishings/rugs_and_carpets",
  "home_and_garden/home_improvement",
  "home_and_garden/home_improvement/construction_and_power_tools",
  "home_and_garden/home_improvement/doors_and_windows",
  "home_and_garden/home_improvement/flooring",
  "home_and_garden/home_improvement/house_painting_and_finishing",
  "home_and_garden/home_improvement/locks_and_locksmiths",
  "home_and_garden/home_improvement/plumbing",
  "home_and_garden/home_improvement/roofing",
  "home_and_garden/home_safety_and_security",
  "home_and_garden/home_safety_and_security/home_alarm_and_security_systems",
  "home_and_garden/home_storage_and_shelving",
  "home_and_garden/home_storage_and_shelving/cabinetry",
  "home_and_garden/home_swimming_pools_saunas_and_spas",
  "home_and_garden/household_supplies",
  "home_and_garden/household_supplies/household_batteries",
  "home_and_garden/household_supplies/household_cleaning_supplies",
  "home_and_garden/kitchen_and_dining",
  "home_and_garden/kitchen_and_dining/cookware_and_diningware",
  "home_and_garden/kitchen_and_dining/major_kitchen_appliances",
  "home_and_garden/kitchen_and_dining/small_kitchen_appliances",
  "home_and_garden/laundry",
  "home_and_garden/laundry/washers_and_dryers",
  "home_and_garden/gardening_and_landscaping",
  "home_and_garden/gardening_and_landscaping/barbecues_and_grills",
  "home_and_garden/gardening_and_landscaping/garden_structures",
  "home_and_garden/gardening_and_landscaping/gardening",
  "home_and_garden/gardening_and_landscaping/landscape_design",
  "home_and_garden/gardening_and_landscaping/lawn_mowers",
  "home_and_garden/gardening_and_landscaping/yard_maintenance",
  "home_and_garden/pest_control",
  "internet_and_telecom",
  "internet_and_telecom/communications_equipment",
  "internet_and_telecom/communications_equipment/radio_equipment",
  "internet_and_telecom/email_and_messaging",
  "internet_and_telecom/email_and_messaging/electronic_spam",
  "internet_and_telecom/email_and_messaging/email",
  "internet_and_telecom/email_and_messaging/text_and_instant_messaging",
  "internet_and_telecom/email_and_messaging/voice_and_video_chat",
  "internet_and_telecom/mobile_and_wireless",
  "internet_and_telecom/mobile_and_wireless/mobile_and_wireless_accessories",
  "internet_and_telecom/mobile_and_wireless/mobile_apps_and_addons",
  "internet_and_telecom/mobile_and_wireless/mobile_phones",
  "internet_and_telecom/search_engines",
  "internet_and_telecom/search_engines/people_search",
  "internet_and_telecom/service_providers",
  "internet_and_telecom/service_providers/cable_and_satellite_providers",
  "internet_and_telecom/service_providers/isps",
  "internet_and_telecom/service_providers/phone_service_providers",
  "internet_and_telecom/teleconferencing",
  "internet_and_telecom/web_services",
  "internet_and_telecom/web_services/affiliate_programs",
  "internet_and_telecom/web_services/cloud_storage",
  "internet_and_telecom/web_services/search_engine_optimization_and_marketing",
  "internet_and_telecom/web_services/web_design_and_development",
  "internet_and_telecom/web_services/web_stats_and_analytics",
  "jobs_and_education",
  "jobs_and_education/education",
  "jobs_and_education/education/academic_conferences_and_publications",
  "jobs_and_education/education/alumni_and_reunions",
  "jobs_and_education/education/colleges_and_universities",
  "jobs_and_education/education/computer_education",
  "jobs_and_education/education/distance_learning",
  "jobs_and_education/education/early_childhood_education",
  "jobs_and_education/education/homeschooling",
  "jobs_and_education/education/open_online_courses",
  "jobs_and_education/education/primary_and_secondary_schooling",
  "jobs_and_education/education/private_tutoring_services",
  "jobs_and_education/education/special_education",
  "jobs_and_education/education/standardized_and_admissions_tests",
  "jobs_and_education/education/study_abroad",
  "jobs_and_education/education/teaching_and_classroom_resources",
  "jobs_and_education/education/training_and_certification",
  "jobs_and_education/education/vocational_and_continuing_education",
  "jobs_and_education/internships",
  "jobs_and_education/jobs",
  "jobs_and_education/jobs/career_resources_and_planning",
  "jobs_and_education/jobs/job_listings",
  "jobs_and_education/jobs/resumes_and_portfolios",
  "law_and_government",
  "law_and_government/government",
  "law_and_government/government/courts_and_judiciary",
  "law_and_government/government/embassies_and_consulates",
  "law_and_government/government/executive_branch",
  "law_and_government/government/government_contracting_and_procurement",
  "law_and_government/government/intelligence_and_counterterrorism",
  "law_and_government/government/legislative_branch",
  "law_and_government/government/lobbying",
  "law_and_government/government/public_policy",
  "law_and_government/government/royalty",
  "law_and_government/government/visa_and_immigration",
  "law_and_government/legal",
  "law_and_government/legal/accident_and_personal_injury_law",
  "law_and_government/legal/bankruptcy",
  "law_and_government/legal/business_and_corporate_law",
  "law_and_government/legal/constitutional_law_and_civil_rights",
  "law_and_government/legal/family_law",
  "law_and_government/legal/intellectual_property",
  "law_and_government/legal/labor_and_employment_law",
  "law_and_government/legal/legal_education",
  "law_and_government/legal/legal_services",
  "law_and_government/legal/product_liability",
  "law_and_government/legal/real_estate_law",
  "law_and_government/military",
  "law_and_government/military/air_force",
  "law_and_government/military/army",
  "law_and_government/military/marines",
  "law_and_government/military/navy",
  "law_and_government/military/veterans",
  "law_and_government/public_safety",
  "law_and_government/public_safety/crime_and_justice",
  "law_and_government/public_safety/emergency_services",
  "law_and_government/public_safety/law_enforcement",
  "law_and_government/public_safety/security_products_and_services",
  "law_and_government/social_services",
  "law_and_government/social_services/welfare_and_unemployment",
  "news",
  "news/business_news",
  "news/business_news/company_news",
  "news/business_news/economy_news",
  "news/business_news/financial_markets_news",
  "news/business_news/fiscal_policy_news",
  "news/gossip_and_tabloid_news",
  "news/gossip_and_tabloid_news/scandals_and_investigations",
  "news/health_news",
  "news/local_news",
  "news/politics",
  "news/politics/campaigns_and_elections",
  "news/politics/media_critics_and_watchdogs",
  "news/politics/political_polls_and_surveys",
  "news/sports_news",
  "news/technology_news",
  "news/weather",
  "news/world_news",
  "online_communities",
  "online_communities/blogging_resources_and_services",
  "online_communities/dating_and_personals",
  "online_communities/dating_and_personals/matrimonial_services",
  "online_communities/dating_and_personals/personals",
  "online_communities/file_sharing_and_hosting",
  "online_communities/online_goodies",
  "online_communities/online_goodies/clip_art_and_animated_gifs",
  "online_communities/online_goodies/skins_themes_and_wallpapers",
  "online_communities/online_goodies/social_network_apps_and_add_ons",
  "online_communities/online_journals_and_personal_sites",
  "online_communities/photo_and_video_sharing",
  "online_communities/photo_and_video_sharing/photo_and_image_sharing",
  "online_communities/photo_and_video_sharing/video_sharing",
  "online_communities/social_networks",
  "online_communities/virtual_worlds",
  "people_and_society",
  "people_and_society/family_and_relationships",
  "people_and_society/family_and_relationships/etiquette",
  "people_and_society/family_and_relationships/family",
  "people_and_society/family_and_relationships/marriage",
  "people_and_society/family_and_relationships/nursery_and_toddlers__playroom",
  "people_and_society/family_and_relationships/romance",
  "people_and_society/family_and_relationships/troubled_relationships",
  "people_and_society/kids_and_teens",
  "people_and_society/kids_and_teens/children_interests",
  "people_and_society/kids_and_teens/teen_interests",
  "people_and_society/religion_and_belief",
  "people_and_society/self_help_and_motivational",
  "people_and_society/seniors_and_retirement",
  "people_and_society/social_issues_and_advocacy",
  "people_and_society/social_issues_and_advocacy/charity_and_philanthropy",
  "people_and_society/social_issues_and_advocacy/discrimination_and_identity_relations",
  "people_and_society/social_issues_and_advocacy/drug_laws_and_policy",
  "people_and_society/social_issues_and_advocacy/ethics",
  "people_and_society/social_issues_and_advocacy/green_living_and_environmental_issues",
  "people_and_society/social_issues_and_advocacy/housing_and_development",
  "people_and_society/social_issues_and_advocacy/human_rights_and_liberties",
  "people_and_society/social_issues_and_advocacy/poverty_and_hunger",
  "people_and_society/social_issues_and_advocacy/work_and_labor_issues",
  "people_and_society/social_sciences",
  "people_and_society/social_sciences/anthropology",
  "people_and_society/social_sciences/archaeology",
  "people_and_society/social_sciences/communications_and_media_studies",
  "people_and_society/social_sciences/demographics",
  "people_and_society/social_sciences/economics",
  "people_and_society/social_sciences/political_science",
  "people_and_society/social_sciences/psychology",
  "people_and_society/subcultures_and_niche_interests",
  "pets_and_animals",
  "pets_and_animals/animal_products_and_services",
  "pets_and_animals/animal_products_and_services/animal_welfare",
  "pets_and_animals/animal_products_and_services/pet_food_and_supplies",
  "pets_and_animals/animal_products_and_services/veterinarians",
  "pets_and_animals/pets",
  "pets_and_animals/pets/birds",
  "pets_and_animals/pets/cats",
  "pets_and_animals/pets/dogs",
  "pets_and_animals/pets/exotic_pets",
  "pets_and_animals/pets/fish_and_aquaria",
  "pets_and_animals/pets/horses",
  "pets_and_animals/pets/rabbits_and_rodents",
  "pets_and_animals/pets/reptiles_and_amphibians",
  "pets_and_animals/wildlife",
  "real_estate",
  "real_estate/property_development",
  "real_estate/real_estate_listings",
  "real_estate/real_estate_listings/bank_owned_and_foreclosed_properties",
  "real_estate/real_estate_listings/commercial_properties",
  "real_estate/real_estate_listings/lots_and_land",
  "real_estate/real_estate_listings/residential_rentals",
  "real_estate/real_estate_listings/residential_sales",
  "real_estate/real_estate_listings/timeshares_and_vacation_properties",
  "real_estate/real_estate_services",
  "real_estate/real_estate_services/property_inspections_and_appraisals",
  "real_estate/real_estate_services/property_management",
  "real_estate/real_estate_services/real_estate_agencies",
  "real_estate/real_estate_services/real_estate_title_and_escrow",
  "reference",
  "reference/directories_and_listings",
  "reference/directories_and_listings/business_and_personal_listings",
  "reference/general_reference",
  "reference/general_reference/biographies_and_quotations",
  "reference/general_reference/calculators_and_reference_tools",
  "reference/general_reference/dictionaries_and_encyclopedias",
  "reference/general_reference/educational_resources",
  "reference/general_reference/forms_guides_and_templates",
  "reference/general_reference/how_to_diy_and_expert_content",
  "reference/general_reference/public_records",
  "reference/general_reference/time_and_calendars",
  "reference/geographic_reference",
  "reference/geographic_reference/maps",
  "reference/humanities",
  "reference/humanities/history",
  "reference/humanities/myth_and_folklore",
  "reference/humanities/philosophy",
  "reference/language_resources",
  "reference/language_resources/foreign_language_resources",
  "reference/libraries_and_museums",
  "reference/libraries_and_museums/libraries",
  "reference/libraries_and_museums/museums",
  "reference/technical_reference",
  "science",
  "science/astronomy",
  "science/biological_sciences",
  "science/biological_sciences/genetics",
  "science/biological_sciences/neuroscience",
  "science/chemistry",
  "science/computer_science",
  "science/computer_science/machine_learning_and_artificial_intelligence",
  "science/earth_sciences",
  "science/earth_sciences/atmospheric_science",
  "science/earth_sciences/geology",
  "science/earth_sciences/paleontology",
  "science/ecology_and_environment",
  "science/ecology_and_environment/climate_change_and_global_warming",
  "science/engineering_and_technology",
  "science/engineering_and_technology/augmented_and_virtual_reality",
  "science/engineering_and_technology/robotics",
  "science/mathematics",
  "science/mathematics/statistics",
  "science/physics",
  "science/scientific_equipment",
  "science/scientific_institutions",
  "sensitive_subjects",
  "sensitive_subjects/accidents_and_disasters",
  "sensitive_subjects/death_and_tragedy",
  "sensitive_subjects/firearms_and_weapons",
  "sensitive_subjects/recreational_drugs",
  "sensitive_subjects/self_harm",
  "sensitive_subjects/violence_and_abuse",
  "sensitive_subjects/war_and_conflict",
  "shopping",
  "shopping/antiques_and_collectibles",
  "shopping/apparel",
  "shopping/apparel/apparel_services",
  "shopping/apparel/athletic_apparel",
  "shopping/apparel/casual_apparel",
  "shopping/apparel/children_clothing",
  "shopping/apparel/clothing_accessories",
  "shopping/apparel/costumes",
  "shopping/apparel/eyewear",
  "shopping/apparel/footwear",
  "shopping/apparel/formal_wear",
  "shopping/apparel/headwear",
  "shopping/apparel/men_clothing",
  "shopping/apparel/outerwear",
  "shopping/apparel/pants_and_shorts",
  "shopping/apparel/shirts_and_tops",
  "shopping/apparel/sleepwear",
  "shopping/apparel/suits_and_business_attire",
  "shopping/apparel/swimwear",
  "shopping/apparel/undergarments",
  "shopping/apparel/uniforms_and_workwear",
  "shopping/apparel/women_clothing",
  "shopping/auctions",
  "shopping/classifieds",
  "shopping/consumer_resources",
  "shopping/consumer_resources/consumer_advocacy_and_protection",
  "shopping/consumer_resources/coupons_and_discount_offers",
  "shopping/consumer_resources/customer_services",
  "shopping/consumer_resources/identity_theft_protection",
  "shopping/consumer_resources/product_reviews_and_price_comparisons",
  "shopping/discount_and_outlet_stores",
  "shopping/entertainment_media",
  "shopping/gifts_and_special_event_items",
  "shopping/gifts_and_special_event_items/custom_and_personalized_items",
  "shopping/gifts_and_special_event_items/flowers",
  "shopping/gifts_and_special_event_items/gifts",
  "shopping/gifts_and_special_event_items/cards_and_greetings",
  "shopping/gifts_and_special_event_items/party_and_holiday_supplies",
  "shopping/green_and_eco_friendly_shopping",
  "shopping/luxury_goods",
  "shopping/mass_merchants_and_department_stores",
  "shopping/photo_and_video_services",
  "shopping/photo_and_video_services/event_and_studio_photography",
  "shopping/photo_and_video_services/photo_printing_services",
  "shopping/photo_and_video_services/stock_photography",
  "shopping/shopping_portals",
  "shopping/swap_meets_and_outdoor_markets",
  "shopping/tobacco_products",
  "shopping/toys",
  "shopping/toys/action_figures",
  "shopping/toys/building_toys",
  "shopping/toys/die_cast_and_toy_vehicles",
  "shopping/toys/dolls_and_accessories",
  "shopping/toys/educational_toys",
  "shopping/toys/outdoor_toys_and_play_equipment",
  "shopping/toys/puppets",
  "shopping/toys/ride_on_toys_and_wagons",
  "shopping/toys/stuffed_toys",
  "shopping/wholesalers_and_liquidators",
  "sports",
  "sports/animal_sports",
  "sports/animal_sports/equestrian",
  "sports/college_sports",
  "sports/combat_sports",
  "sports/combat_sports/boxing",
  "sports/combat_sports/fencing",
  "sports/combat_sports/martial_arts",
  "sports/combat_sports/wrestling",
  "sports/extreme_sports",
  "sports/extreme_sports/climbing_and_mountaineering",
  "sports/extreme_sports/drag_and_street_racing",
  "sports/extreme_sports/stunts_and_dangerous_feats",
  "sports/fantasy_sports",
  "sports/individual_sports",
  "sports/individual_sports/bowling",
  "sports/individual_sports/cycling",
  "sports/individual_sports/golf",
  "sports/individual_sports/gymnastics",
  "sports/individual_sports/racquet_sports",
  "sports/individual_sports/running_and_walking",
  "sports/individual_sports/skate_sports",
  "sports/individual_sports/track_and_field",
  "sports/international_sports_competitions",
  "sports/international_sports_competitions/olympics",
  "sports/motor_sports",
  "sports/motor_sports/auto_racing",
  "sports/motor_sports/motorcycle_racing",
  "sports/sport_scores_and_statistics",
  "sports/sporting_goods",
  "sports/sporting_goods/american_football_equipment",
  "sports/sporting_goods/baseball_equipment",
  "sports/sporting_goods/basketball_equipment",
  "sports/sporting_goods/combat_sports_equipment",
  "sports/sporting_goods/cricket_equipment",
  "sports/sporting_goods/electric_skateboards_and_scooters",
  "sports/sporting_goods/equestrian_equipment_and_tack",
  "sports/sporting_goods/golf_equipment",
  "sports/sporting_goods/gymnastics_equipment",
  "sports/sporting_goods/hockey_equipment",
  "sports/sporting_goods/ice_skating_equipment",
  "sports/sporting_goods/roller_skating_and_rollerblading_equipment",
  "sports/sporting_goods/skateboarding_equipment",
  "sports/sporting_goods/soccer_equipment",
  "sports/sporting_goods/sports_memorabilia",
  "sports/sporting_goods/tennis_equipment",
  "sports/sporting_goods/water_sports_equipment",
  "sports/sporting_goods/winter_sports_equipment",
  "sports/sports_coaching_and_training",
  "sports/sports_fan_gear_and_apparel",
  "sports/team_sports",
  "sports/team_sports/american_football",
  "sports/team_sports/australian_football",
  "sports/team_sports/baseball",
  "sports/team_sports/basketball",
  "sports/team_sports/cheerleading",
  "sports/team_sports/cricket",
  "sports/team_sports/handball",
  "sports/team_sports/hockey",
  "sports/team_sports/rugby",
  "sports/team_sports/soccer",
  "sports/team_sports/volleyball",
  "sports/water_sports",
  "sports/water_sports/surfing",
  "sports/water_sports/swimming",
  "sports/winter_sports",
  "sports/winter_sports/ice_skating",
  "sports/winter_sports/skiing_and_snowboarding",
  "travel",
  "travel/hotels_and_accommodations",
  "travel/hotels_and_accommodations/vacation_rentals_and_short_term_stays",
  "travel/luggage_and_travel_accessories",
  "travel/luggage_and_travel_accessories/backpacks_and_utility_bags",
  "travel/specialty_travel",
  "travel/specialty_travel/adventure_travel",
  "travel/specialty_travel/agritourism",
  "travel/specialty_travel/business_travel",
  "travel/specialty_travel/ecotourism",
  "travel/specialty_travel/family_travel",
  "travel/specialty_travel/honeymoons_and_romantic_getaways",
  "travel/specialty_travel/low_cost_and_last_minute_travel",
  "travel/specialty_travel/luxury_travel",
  "travel/specialty_travel/religious_travel",
  "travel/tourist_destinations",
  "travel/tourist_destinations/beaches_and_islands",
  "travel/tourist_destinations/historical_sites_and_buildings",
  "travel/tourist_destinations/mountain_and_ski_resorts",
  "travel/tourist_destinations/regional_parks_and_gardens",
  "travel/tourist_destinations/theme_parks",
  "travel/tourist_destinations/vineyards_and_wine_tourism",
  "travel/tourist_destinations/zoos_aquariums_preserves",
  "travel/air_travel",
  "travel/airport_parking_and_transportation",
  "travel/car_rentals",
  "travel/carpooling",
  "travel/chartered_transportation_rentals",
  "travel/cruises_and_charters",
  "travel/general_parking",
  "travel/bus_and_rail",
  "travel/scooter_and_bike_rentals",
  "travel/taxi_and_ride_hail_services",
  "travel/traffic_and_route_planners",
  "travel/urban_transit",
  "travel/travel_agencies_and_services",
  "travel/travel_agencies_and_services/guided_tours_and_escorted_vacations",
  "travel/travel_agencies_and_services/sightseeing_tours",
  "travel/travel_agencies_and_services/vacation_offers",
  "travel/travel_guides_and_travelogues",
];

const COLORS = {
  Adult: "#e30000",
  arts_and_entertainment: "#FF7826",
  autos_and_vehicles: "#a9a3ab",
  beauty_and_fitness: "#FA4E7C",
  books_and_literature: "#C96CFD",
  business_and_industrial: "#C09900",
  computers_and_electronics: "#1ACB78",
  finance: "#F29F0C",
  food_and_drink: "#D98FAA",
  games: "#73D2DE",
  health: "#BC4E55",
  hobbies_and_leisure: "#ff599e",
  home_and_garden: "#8390FA",
  internet_and_telecom: "#0887C9",
  jobs_and_education: "#09777E",
  law_and_government: "#2aa8ff",
  news: "#FF9770",
  online_communities: "#F1C454",
  people_and_society: "#BE45B0",
  pets_and_animals: "#d05434",
  real_estate: "#d70fa2",
  reference: "#57A8D2",
  science: "#00AE9D",
  sensitive_subjects: "#F94144",
  shopping: "#DB4E69",
  sports: "#90BE6D",
  travel: "#9e7eb3",
};

export function getContentClassificationColor(category: string) {
  const categories = split(category, "/");
  const mainCategory = head(categories);
  const color = mainCategory
    ? (get(COLORS, mainCategory, "#5E3B75") as string)
    : "#5E3B75";
  if (categories.length > 1) {
    return lighten(categories.length > 2 ? 0.2 : 0.1, color);
  } else {
    return color;
  }
}

export function getAllContentClassifications() {
  return CLASSIFICATIONS;
}

export const getContentClassificationLabel = (
  category: string,
  locale: Locale
): string =>
  tr(locale, `FACETS::CONTENT_CLASSIFICATION_${category.replace(/\//g, "_")}`);
